import React, { useState } from "react";
import attributeStyles from "./scss/attributes.module.scss";
const SalesVolumeList = () => {
  const [sortField, setSortField] = useState("");
  const [sortType, setSortType] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [queryParams, setQueryParams] = useState({});
  const handleSortChange = (field, type) => {
    setSortField(field);
    setSortType(type);
    setQueryParams({
      filter_range: "",
      [field]: type,
    });
  };
  return (
    <>
      <table className={attributeStyles.table}>
        <thead>
          <tr>
            <th>NFT Details</th>
            <th
              onClick={() =>
                handleSortChange(
                  "nft_attribute",
                  sortType === "ASC" ? "DESC" : "ASC"
                )
              }
            >
              Properties (Type){" "}
              <i
                className={`fa-solid ${
                  sortField === "nft_attribute"
                    ? sortType === "DESC"
                      ? "fa-sort-down"
                      : "fa-sort-up"
                    : "fa-sort"
                }`}
              ></i>
            </th>
            <th>
              Attributes{" "}
              <i
                className={`fa-solid ${
                  sortField === "attributes"
                    ? sortType === "DESC"
                      ? "fa-sort-down"
                      : "fa-sort-up"
                    : "fa-sort"
                }`}
              ></i>
            </th>
            <th
              onClick={() =>
                handleSortChange(
                  "last_price",
                  sortType === "ASC" ? "DESC" : "ASC"
                )
              }
            >
              Price{" "}
              <i
                className={`fa-solid ${
                  sortField === "last_price"
                    ? sortType === "DESC"
                      ? "fa-sort-down"
                      : "fa-sort-up"
                    : "fa-sort"
                }`}
              ></i>
            </th>
            <th
              onClick={() =>
                handleSortChange(
                  "highest_price",
                  sortType === "ASC" ? "DESC" : "ASC"
                )
              }
            >
              Seller{" "}
              <i
                className={`fa-solid ${
                  sortField === "highest_price"
                    ? sortType === "DESC"
                      ? "fa-sort-down"
                      : "fa-sort-up"
                    : "fa-sort"
                }`}
              ></i>
            </th>
            <th
              onClick={() =>
                handleSortChange(
                  "total_sales",
                  sortType === "ASC" ? "DESC" : "ASC"
                )
              }
            >
              Buyer{" "}
              <i
                className={`fa-solid ${
                  sortField === "total_sales"
                    ? sortType === "DESC"
                      ? "fa-sort-down"
                      : "fa-sort-up"
                    : "fa-sort"
                }`}
              ></i>
            </th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </>
  );
};

export default SalesVolumeList;
